import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { IQuestionCategory } from '../../../../interfaces/question-category.interface';

export interface ICheckListsFilters {
  category: string;
  search: string;
}

@Component({
  selector: 'app-check-lists-filters',
  templateUrl: './check-lists-filters.component.html',
  styleUrls: ['./check-lists-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckListsFiltersComponent {
  filtersForm = this.fb.group({
    category: '',
    search: '',
  });

  @Input() categories: IQuestionCategory[];

  @Output() changedCategory = new EventEmitter<IQuestionCategory>();
  @Output() applied = new EventEmitter<ICheckListsFilters>();
  @Output() reset = new EventEmitter<ICheckListsFilters>();
  @Output() created = new EventEmitter<ICheckListsFilters>();

  constructor(private fb: UntypedFormBuilder) {}

  handleReset(): void {
    this.filtersForm.patchValue({ search: '' });
    this.reset.emit();
  }

  handleChangeCategory(selectedCategory: IQuestionCategory): void {
    this.changedCategory.emit({
      ...this.filtersForm.value,
      category: (selectedCategory && selectedCategory.id) || '',
    });
  }

  handleApply(): void {
    this.applied.emit(this.value);
  }

  handleCreate(): void {
    this.created.emit(this.value);
  }

  get value(): ICheckListsFilters {
    const { category, search } = this.filtersForm.value;
    return {
      search,
      category: (category && category.id) || '',
    };
  }
}
